import React from "react";
import { Maximize, Minimize } from "lucide-react";
import { Button } from "@/components/ui/button";
import useFullscreen from "@/hooks/useFullScreen";
import FullscreenNotification from "./fullscreenNotification";

interface FullscreenButtonProps {
  iconsOnly?: boolean;
}

const FullscreenButton: React.FC<FullscreenButtonProps> = ({ iconsOnly = false }) => {
  const { isFullscreen, toggleFullscreen } = useFullscreen();

  // Gemensam style för header-knappar med bara ikoner
  const headerButtonStyle = "bg-gray-800/50 text-gray-300 border border-gray-700 hover:bg-orange-300/10 hover:text-orange-300 transition-colors flex items-center justify-center h-9 w-9 p-0";

  if (iconsOnly) {
    return (
      <Button
        variant="outline"
        size="icon"
        className={headerButtonStyle}
        onClick={toggleFullscreen}
        aria-label={isFullscreen ? "Avsluta fullskärm" : "Visa i fullskärm"}
        title={isFullscreen ? "Avsluta fullskärm" : "Visa i fullskärm"}
      >
        {isFullscreen ? <Minimize className="h-4 w-4" /> : <Maximize className="h-4 w-4" />}
      </Button>
    );
  }

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        className="bg-gray-800/50 text-gray-300 border border-gray-700 hover:bg-orange-300/10 hover:text-orange-300 transition-colors"
        onClick={toggleFullscreen}
      >
        {isFullscreen ? (
          <>
            <Minimize className="h-4 w-4 mr-2" />
            <span className="hidden sm:inline">Avsluta fullskärm</span>
          </>
        ) : (
          <>
            <Maximize className="h-4 w-4 mr-2" />
            <span className="hidden sm:inline">Fullskärm</span>
          </>
        )}
      </Button>
      <FullscreenNotification isFullscreen={isFullscreen} />
    </>
  );
};

export default FullscreenButton;